const WHATSAPP_NUMBER = '2349039844951';

export default function WhatsAppButton() {
  const handleClick = () => {
    window.open(`https://wa.me/${WHATSAPP_NUMBER}`, '_blank', 'noopener,noreferrer');
  };

  return (
    <button
      onClick={handleClick}
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 left-6 z-50 flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white px-4 py-3 rounded-full shadow-lg hover:shadow-green-500/40 transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap group"
    >
      <span className="w-6 h-6 flex items-center justify-center text-xl leading-none">
        <i className="ri-whatsapp-line"></i>
      </span>
      <span className="text-sm font-semibold max-w-0 overflow-hidden group-hover:max-w-xs transition-all duration-300 whitespace-nowrap">
        Chat on WhatsApp
      </span>
    </button>
  );
}
